export default {
  data() {
    return {
      valid: {
        title: false,
        attribute: false,
        unit_value: false,
        quantity: false,
      },
      touched: {
        title: false,
        attribute: false,
        unit_value: false,
        quantity: false,
      },
      success: {
        title: false,
        attribute: false,
        unit_value: false,
        quantity: false,
      },
      error: {
        title: '',
        attribute: '',
        unit_value: '',
        quantity: '',
      },
      errorMessages: {
        titleRequired: {
          el: 'Ο τίτλος πρέπει να υπάρχει σε όλες τις γλώσσες',
          en: 'Title must exist in all three languages',
          it: 'Il titolo deve esistere in tutte e tre le lingue',
        },
        attributeRequired: {
          el: 'Το attribute είναι υποχρεωτικό',
          en: 'Attribute is required',
          it: "L'attributo è obbligatorio",
        },
        attributeNotUnique: {
          el: 'Το attribute πρέπει να είναι μοναδικό',
          en: 'Attribute must be unique',
          it: "L'attributo deve essere univoco",
        },
        attributeInvalidChars: {
          el: 'Το attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, παύλα και κάτω παύλα',
          en: 'Attribute may only contain letters, numbers, hyphen and underscore',
          it: "L'attributo può contenere solo lettere, numeri, trattino e underscore",
        },
        unitValueMin: {
          el: 'Η αξία μονάδας πρέπει να είναι τουλάχιστον 0,1',
          en: 'Unit value must be at least 0.1',
          it: 'Il valore unitario deve essere almeno 0.1',
        },
        quantityMin: {
          el: 'Η ποσότητα πρέπει να είναι τουλάχιστον 1',
          en: 'Quantity must be at least 1',
          it: 'La quantità deve essere almeno 1',
        },
      },
    };
  },

  computed: {
    formValid() {
      return (
        this.valid.title && this.valid.attribute && this.valid.unit_value && this.valid.quantity
      );
    },
  },

  methods: {
    validateTitle() {
      const title = this.invoiceItemDialog?.form?.title || {};
      const hasEl = !!(title && title.el);
      const hasEn = !!(title && title.en);
      const hasIt = !!(title && title.it);
      const isValid = hasEl && hasEn && hasIt;
      this.valid.title = isValid;
      this.success.title = isValid && this.touched.title;
      if (!isValid) {
        this.error.title = this.touched.title ? this.errorMessages.titleRequired[this.lang] : '';
      } else {
        this.error.title = '';
      }
    },

    validateAttribute() {
      const attr = (this.invoiceItemDialog?.form?.attribute || '').toString().trim();
      if (!attr) {
        this.valid.attribute = false;
        this.success.attribute = false;
        this.error.attribute = this.touched.attribute
          ? this.errorMessages.attributeRequired[this.lang]
          : '';
        return;
      }

      const allowed = /^[A-Za-z0-9_-]+$/;
      if (!allowed.test(attr)) {
        this.valid.attribute = false;
        this.success.attribute = false;
        this.error.attribute = this.touched.attribute
          ? this.errorMessages.attributeInvalidChars[this.lang]
          : '';
        return;
      }

      const invoice = this.currentBilling?.invoice || {};
      let exists = false;
      for (const [, item] of Object.entries(invoice)) {
        if (!item || !item.is_custom) continue;
        if (item.attribute === attr) {
          // if editing allow same item
          if (
            this.invoiceItemDialog.mode === 'edit' &&
            this.invoiceItemDialog.originalItem &&
            item.invoice_item_id === this.invoiceItemDialog.originalItem.invoice_item_id
          ) {
            continue;
          }
          exists = true;
          break;
        }
      }

      if (exists) {
        this.valid.attribute = false;
        this.success.attribute = false;
        this.error.attribute = this.touched.attribute
          ? this.errorMessages.attributeNotUnique[this.lang]
          : '';
      } else {
        this.valid.attribute = true;
        this.success.attribute = this.touched.attribute;
        this.error.attribute = '';
      }
    },

    validateUnitValue() {
      const val = Number(this.invoiceItemDialog?.form?.unit_value);
      const isValid = !(isNaN(val) || val < 0.1);
      this.valid.unit_value = isValid;
      this.success.unit_value = isValid && this.touched.unit_value;
      this.error.unit_value = !isValid
        ? this.touched.unit_value
          ? this.errorMessages.unitValueMin[this.lang]
          : ''
        : '';
    },

    validateQuantity() {
      const q = Number(this.invoiceItemDialog?.form?.quantity);
      const isValid = !(isNaN(q) || q < 1);
      this.valid.quantity = isValid;
      this.success.quantity = isValid && this.touched.quantity;
      this.error.quantity = !isValid
        ? this.touched.quantity
          ? this.errorMessages.quantityMin[this.lang]
          : ''
        : '';
    },
  },

  watch: {
    'invoiceItemDialog.form.title.el': {
      immediate: true,
      handler() {
        this.validateTitle();
      },
    },
    'invoiceItemDialog.form.title.en': {
      immediate: true,
      handler() {
        this.validateTitle();
      },
    },
    'invoiceItemDialog.form.title.it': {
      immediate: true,
      handler() {
        this.validateTitle();
      },
    },
    'invoiceItemDialog.form.attribute': {
      immediate: true,
      handler() {
        this.validateAttribute();
      },
    },
    'invoiceItemDialog.form.unit_value': {
      immediate: true,
      handler() {
        this.validateUnitValue();
      },
    },
    'invoiceItemDialog.form.quantity': {
      immediate: true,
      handler() {
        this.validateQuantity();
      },
    },
  },
};
